(() => {
  const key = 'lac-recent-products-v1';
  const readHistory = () => {
    try {
      const saved = JSON.parse(localStorage.getItem(key) || '[]');
      return Array.isArray(saved) ? [...new Set(saved.map(handle => handle === 'luxe-lightwrap-kit-test' ? 'luxe-lightwrap-kit' : handle).filter(handle => typeof handle === 'string' && /^[a-z0-9-]+$/.test(handle)))].slice(0, 20) : [];
    } catch (_) { return []; }
  };
  const current = document.querySelector('[data-lac-viewed-product]')?.dataset.lacViewedProduct;
  if (current) {
    try { localStorage.setItem(key, JSON.stringify([current, ...readHistory().filter(handle => handle !== current)].slice(0, 20))); } catch (_) { /* Storage is optional. */ }
  }
  const instances = new WeakMap();
  function initialize(root = document) {
    root.querySelectorAll('[data-lac-recent]').forEach(section => {
      const handles = readHistory().slice(0, Number(section.dataset.limit) || 8);
      const signature = handles.join(',');
      const previous = instances.get(section);
      if (previous?.signature === signature) return;
      previous?.observer?.disconnect();
      const state = { signature, observer: null };
      instances.set(section, state);
      if (!handles.length) return;
      const load = async () => {
        const cards = await Promise.all(handles.map(async handle => {
          const controller = new AbortController();
          const timer = setTimeout(() => controller.abort(), 10000);
          try {
            const rootPath = (section.dataset.root || '/').replace(/\/?$/, '/');
            const url = new URL(rootPath + 'products/' + encodeURIComponent(handle), location.origin);
            url.searchParams.set('section_id', 'lac-recently-viewed');
            if (section.dataset.theme) url.searchParams.set('preview_theme_id', section.dataset.theme);
            const response = await fetch(url, { signal: controller.signal });
            if (!response.ok) return null;
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            return doc.querySelector('.lac-recent-products__card');
          } catch (_) { return null; }
          finally { clearTimeout(timer); }
        }));
        if (!section.isConnected || instances.get(section) !== state) return;
        const track = section.querySelector('.lac-recent-products__track');
        if (!track) return;
        track.replaceChildren(...cards.filter(Boolean).map(card => document.importNode(card, true)));
        section.hidden = !track.children.length;
      };
      if ('IntersectionObserver' in window) {
        state.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) { state.observer.disconnect(); load(); }
        }, { rootMargin: '500px' });
        state.observer.observe(section.parentElement);
      } else { load(); }
    });
  }
  initialize();
  window.addEventListener('pageshow', event => { if (event.persisted) initialize(); });
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
